import React, { useState } from "react";

import { Accordion, AccordionDetails, Box, styled } from "@mui/material";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { IOpportunities } from "store/types";

import { Banner } from "./Banner";
import { Graph } from "./Graph";
import { GraphTabs } from "./GraphTabs";

const StyledAccordionSummary = styled(MuiAccordionSummary)({
  cursor: "default !important",
  borderRadius: "8px",
  padding: 0,
  "&:hover": {
    cursor: "default !important"
  },
  ".MuiAccordionSummary-content": {
    margin: 0
  },
  ".Mui-expanded": {
    margin: "0 !important"
  },
});

interface Props {
  opportunity: IOpportunities;
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Opportunity: React.FC<Props> = ({ opportunity, isExpanded, setIsExpanded }) => {
  const graphKeys = Object.keys(opportunity.graphs);
  const [currentGraphKey, setCurrentGraphKey] = useState<string>(graphKeys[0]);

  const handlePickGraph = (_: React.SyntheticEvent, graphKey: string) => {
    setCurrentGraphKey(graphKey);
  };

  return (
    <Accordion
      expanded={isExpanded}
      sx={{
        "&& .MuiPaper-root": {
          borderRadius: "8px !important",
          boxShadow: "none",
          "&:before": {
            display: "none"
          }
        },
        "&.MuiAccordion-root": {
          "&:before": {
            display: "none"
          }
        },
        "&.Mui-expanded": {
          margin: 0
        }
      }}
    >
      <StyledAccordionSummary>
        <Banner opportunity={opportunity} isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
      </StyledAccordionSummary>
      {Boolean(Object.keys(opportunity.graphs).length) && (
        <AccordionDetails
          sx={{
            display: "flex",
            flexDirection: "column",
            bgcolor: "#F6F8FC",
            p: "0 20px 16px 20px",
            gap: "16px"
          }}
        >
          <GraphTabs value={currentGraphKey} handleChange={handlePickGraph} graphKeys={graphKeys} />
          <Box>
            <Graph
              key={`${opportunity.id}-${currentGraphKey}`}
              categories={opportunity.graphs[currentGraphKey].categories}
              series={opportunity.graphs[currentGraphKey].series}
            />
          </Box>
        </AccordionDetails>
      )}
    </Accordion>
  );
};
